import type {
  CountryDistributionItem,
  DashboardStats,
  FundraisingResponse,
  LatestDelivery,
  ListResponse,
  MonthlyAddedItem,
  NotificationResponse,
  ProfileCategoryCountsResponse,
  ProfileResponse,
  SourceSplitItem,
  TopCompatibleLP,
} from '@shared/schemas';

import api from '@/shared/api/api-client';

import { scopeQuery } from '../domain/scope';
import type { DashboardGateway } from './dashboard.gateway';

/**
 * Real implementation over the shared api client; paths kept 1:1 with the
 * dashboard's reads.
 */
export const httpDashboardGateway: DashboardGateway = {
  fetchNotifications: () => api.get<NotificationResponse[]>('/notifications'),
  fetchLists: () => api.get<ListResponse[]>('/lists'),
  fetchCountryDistribution: (scope) =>
    api.get<CountryDistributionItem[]>(`/dashboard/country-distribution${scopeQuery(scope)}`),
  fetchTopCompatibleLps: () => api.get<TopCompatibleLP[]>('/dashboard/top-compatible-lps'),
  // Five: the card shows a shortlist, the Tracked LPs page the whole of it.
  fetchTrackedProfiles: () => api.get<ProfileResponse[]>('/profiles?favorite=true&limit=5'),
  fetchStats: (scope) => api.get<DashboardStats>(`/dashboard/stats${scopeQuery(scope)}`),
  fetchLatestFundraising: () => api.get<FundraisingResponse | null>('/fundraisings/latest'),
  fetchSourceSplit: (scope) =>
    api.get<SourceSplitItem[]>(`/dashboard/source-split${scopeQuery(scope)}`),
  fetchTypeCounts: (scope) =>
    api.get<ProfileCategoryCountsResponse>(`/dashboard/type-counts${scopeQuery(scope)}`),
  fetchMonthlyAdded: (scope) =>
    api.get<MonthlyAddedItem[]>(`/dashboard/monthly-added${scopeQuery(scope)}`),
  // Wrapped in `{ delivery }`: a bare `data: null` would come back as the envelope.
  fetchLatestDelivery: () =>
    api
      .get<{ delivery: LatestDelivery | null }>('/dashboard/latest-delivery')
      .then((r) => r.delivery),
};
